
import { computed, defineComponent, onMounted, ref, getCurrentInstance } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { SMCases } from "@/store";

import {
  API_TCandidate_Case,
  TCandidate_Case,
  convertCaseForTable,
  buttonModel,
} from "@/models/candidate";

export default defineComponent({
  name: "VEmployerVisaCasesBrowse",

  components: {},

  setup() {
    const instance = getCurrentInstance()?.proxy;
    const route = instance?.$route;
    const router = instance?.$router;

    const candidateId = computed(() => Number(route.params.candidateId ?? 0));

    async function onTableAction(item: TCandidate_Case) {
      if (item.tasks_to_do) {
        if (!item.case_id) return;

        await router.push(`/cases/${item.case_id}/dashboard/${SMCases.tabId}`);

        return;
      }

      if (item.service === "Eligibility Check") {
        await router.push(
          `/cases/${item.case_id}/report/1?report_template_alias=ca_report_candidate_assessment&name=eligibility_report`
        );
      }
    }

    async function onServiceClick(item: TCandidate_Case) {
      if (!item.case_id) return;

      await router.push(`/cases/${item.case_id}/dashboard/${SMCases.tabId}`);
    }

    const headers = [
      {
        label: "Service",
        value: "service",
        action: onServiceClick,
      },
      {
        label: "Owner",
        value: "owner_name",
      },
      {
        label: "Start Date",
        value: "start_date",
        info: "This is the date the service was initiated on the platform",
      },
      {
        label: "Status",
        value: "status",
      },
      {
        label: "Action Required",
        value: "actions",
      },
    ];

    const services = ref<TCandidate_Case[]>([]);

    const loading = ref(false);

    async function fetchData() {
      if (!candidateId.value) return;

      try {
        loading.value = true;

        const { data } = await axios.get<API_TCandidate_Case[]>(
          API_ROUTES.CANDIDATE_USER_CASES(candidateId.value)
        );

        if (!data) return;

        services.value = data.map((item) => convertCaseForTable(item));
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => fetchData());

    const button = buttonModel;

    return {
      headers,
      services,
      loading,
      button,
      onTableAction,
    };
  },
});
